import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../../history'

import { notify } from 'react-notify-toast'
import moment from 'moment'
import { isMobile } from 'react-device-detect'
import { deleteFeed } from '../../../Api/backendApi'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import GenericCard from '../../../GenericComponents/GenericMainCard'

interface RemoveProgressModalInterface {
  closeModal: Function
  feedId: number
  handleGoToMainPage: Function
}

const RemoveProgressModal: FC<RemoveProgressModalInterface> = ({
  closeModal,
  feedId,
  handleGoToMainPage,
}) => {
  const handleDeleteFeed = async (feedId: number) => {
    await deleteFeed(feedId)

    setTimeout(() => {
      handleGoToMainPage(true)
      closeModal()
    }, 1000)
  }

  return (
    <GenericCard
      flexDir={'column'}
      className="standard"
      width={'100%'}
      margin={' auto'}
    >
      <GenericCloseButton onClick={closeModal} />

      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          Usuń wpis
        </GenericTextSpan>
      </GenericRow>

      <GenericRow>
        <GenericTextSpan
          fSize={'1.4rem'}
          margin={'3% 0 0 0'}
          fWeight={'bold'}
          width={isMobile ? '90%' : '60%'}
        >
          Czy na pewno chcesz usunąć wpis? Operacja ta jest nieodwracalna.
        </GenericTextSpan>
      </GenericRow>
      <GenericRow>
        <GenericButton
          width={'40%'}
          className="danger"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => handleDeleteFeed(feedId)}
        >
          Usuń wpis
        </GenericButton>
        <GenericButton
          width={'40%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => closeModal()}
        >
          Anuluj
        </GenericButton>
      </GenericRow>
    </GenericCard>
  )
}

export default RemoveProgressModal
